export default __webpack_public_path__ + "static/media/attach-file.71ab1509.svg";